import React from 'react';
import {Col, Row, Button} from "react-materialize";
import Input from "./components/Input";
import ButtonMy from "./components/Button";
import Firebase from "firebase";

import CryptoFunction from "./functions/CryptoFunctions";
import Cookies from "universal-cookie/es6";
import {Redirect} from "react-router-dom";
import {VKApi, ConsoleLogger} from 'node-vk-sdk'
import PassView from "./components/PassView";

const cookie = new Cookies();
const api = new VKApi({
    logger: new ConsoleLogger()
})

class MyAccount extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            sid: cookie.get('_VKAuth'),
            mid: cookie.get('_VKAuthMID'),
            userName: "",
            lastKey: null,
            curPass: null,
            passList: [],
            passName: null,
        }
    }

    componentDidMount() {

        Firebase.firestore().collection('passwords')
            .where('mid', '==', this.state.mid)
            .get()
            .then((el)=>{
                el.forEach((el)=>{
                    this.setState({
                        passList: [...this.state.passList, el.data()]
                    })
                })
            })
    }

    setNewKey = (e)=>{
        this.setState({
            lastKey: e.target.value === "" ? null : e.target.value
        })
    }

    setPassName = (e)=>{
        this.setState({
            passName: e.target.value,
        })
    }

    setPass = (e)=>{
        this.setState({
            curPass: e.target.value
        })
    }

    savePass = ()=>{
        if (this.state.lastKey !== null && this.state.curPass !== null && this.state.passName !== null) {
            let pass = {
                id: Math.round(Math.random()*1000),
                name: this.state.passName,
                mid: this.state.mid,
                password: CryptoFunction.megaHardPizdecEncrypt(this.state.curPass, this.state.lastKey)
            };
            Firebase.firestore()
                .collection('passwords')
                .add(pass)
                .then((el)=>{
                    this.setState({
                        passList: [...this.state.passList, pass],
                        curPass: null,
                        passName: null
                    })
                })
        }
    }

    onCopyKey = ()=>{
        window.navigator.clipboard.writeText(this.state.lastKey).then((el)=>{
            window.M.toast({html: "Copied!"})
        });
    }

    deletePass = (id, i)=>{
        this.setState({
            passList: [...this.state.passList.slice(0, i), ...this.state.passList.slice(i+1)]
        })
        Firebase.firestore()
            .collection('passwords')
            .where('id', '==', id)
            .get()
            .then((e)=>{
                e.forEach((doc)=>{
                    doc.ref.delete().then()
                })
            });
    }

    render() {

        return (
            <div className={'container'}>
                <Row>
                    <Col s={12} m={10} offset={'m1'}>
                        {this.props.auth ?
                            <React.Fragment>
                                <div className="card pink lighten-5">
                                    <div className="card-content">
                                        <span className="card-title">Здравствуй, {this.state.userName}</span>
                                        <div>
                                            <h5>Мененджер паролей</h5>
                                            <span>Ключ для шифрования пароля (ВНИМАНИЕ! Вам нужно использовать один ключ для шифрования ВСЕХ паролей!):</span>
                                            <Input
                                                editInput={this.setNewKey}
                                                editInputValue={this.state.lastKey}
                                                onPaste={null}
                                                onCopy={this.onCopyKey}
                                                isKey
                                                isLongKey
                                            />
                                            <span>Имя:</span>
                                            <Input
                                                editInput={this.setPassName}
                                                editInputValue={this.state.passName}
                                                onPaste={null}
                                                onCopy={null}
                                            />
                                            <span>Пароль:</span>
                                            <Input
                                                editInput={this.setPass}
                                                editInputValue={this.state.curPass}
                                                onPaste={null}
                                                onCopy={null}
                                            />
                                            <ButtonMy
                                                text={"Добавить"}
                                                whyAreYouRunning={this.savePass}
                                            />
                                            {this.state.passList.length > 0 ? <div>{this.state.passList.map((el, i)=>
                                                <PassView
                                                    key={i}
                                                    id={el.id}
                                                    idI={i}
                                                    name={el.name}
                                                    chipher={el.password}
                                                    lastKey={this.state.lastKey}

                                                    delete={this.deletePass}
                                                />)}</div> : null}
                                        </div>

                                    </div>
                                </div>
                                <Button onClick={()=>this.props.exit()} className='purple darken-1'>Выйти</Button>
                            </React.Fragment>
                        : <Redirect to={'/'} />}
                    </Col>

                </Row>
            </div>
        )
    }
}

export default MyAccount;